module.exports = __webpack_public_path__ + "static/media/5.74117c2d.svg";